function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import styled from "styled-components";
import { media } from "sprout-ui-theme";
import { Button as BaseButton } from "sprout-ui-dom/dist/Button";
import { Menu, MenuItem, MenuTitle, MenuTrigger, useMenuState } from "@sprout/list-navigation/dist/Menu";
import { ArchiveOutlined, DeleteOutlined, EditOutlined, MoreHoriz, RestoreFromTrashOutlined, UnarchiveOutlined } from "sprout-ui-icons";
const Button = styled(BaseButton)`
  position: absolute;
  top: 0;
  right: -40px;

  width: 40px;
  height: 40px;

  opacity: 0;

  ${media.up("medium", "pointer")} {
    :hover {
      opacity: 1;
    }
  }

  ${media.down("medium")} {
    display: none;
  }
`;
const PostPageTodoListMenu = (props)=>{
    const { todoList , onOpen , onClose  } = props;
    const { isExplicitlyArchived , isExplicitlyDeleted , deletedAt  } = todoList;
    const menuState = useMenuState();
    const { open  } = menuState;
    useEffect(()=>{
        if (open) onOpen();
        else onClose();
    }, [
        onClose,
        onOpen,
        open
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "circle",
                    className: "PostPageTodoListMenu",
                    children: /*#__PURE__*/ _jsx(MoreHoriz, {})
                })
            })),
            /*#__PURE__*/ _jsxs(Menu, _objectSpread({}, menuState, {
                children: [
                    /*#__PURE__*/ _jsx(MenuTitle, {
                        children: "To-do list Options"
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        icon: EditOutlined,
                        action: "EDIT_TODOLIST",
                        label: "Edit"
                    }),
                    !deletedAt && /*#__PURE__*/ _jsx(MenuItem, {
                        action: "ARCHIVE",
                        icon: isExplicitlyArchived ? UnarchiveOutlined : ArchiveOutlined,
                        label: isExplicitlyArchived ? "Unarchive" : "Archive"
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        action: "DELETE",
                        icon: isExplicitlyDeleted ? RestoreFromTrashOutlined : DeleteOutlined,
                        label: isExplicitlyDeleted ? "Restore" : "Trash"
                    })
                ]
            }))
        ]
    });
};
export default PostPageTodoListMenu;
